<template src="./filterCommon.pug" lang="pug"></template>

<script>
export default {
  name: 'FiltersCommon',

  props: {
    options: {
      type: Array,
      required: true
    },
    onChange: {
      type: Function,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    hasGroups: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      hasData: false,
      shown: false,
      selected: {},
      disabled: false,
      disabledText: this.$t('dashboard.filtro.semOpcoes'),
      element: null,
      selectedTextElement: null
    }
  },

  methods: {
    select (selected) {
      selected.__selected = true
      this.selected.__selected = false
      this.selected = selected
      this.onChange(selected)
      this.close()
    },

    getDisplayOptions (group) {
      if (group) {
        return group.options.filter(option => !option.__selected).sort()
      }
      return this.options.filter(option => !option.__selected).sort()
    },

    getSelected () {
      let selected

      if (this.hasGroups) {
        for (const group of this.options) {
          if (group.__selected) {
            selected = group.options.find(option => option.__selected)
            break
          }
        }

        if (!selected) {
          selected = this.options.find(group => group.default).options[0]
        }
      } else {
        selected = this.options.find(option => option.__selected) || this.options[0]
      }

      selected.__selected = true
      this.onChange(selected)
      return selected
    },

    getTitle (label) {
      const title = this.disabled ? this.disabledText : label

      if (!this.element) {
        return title
      }

      if (!this.selectedTextElement) {
        const span = this.element.getElementsByClassName('filter-common-selected-text')
        if (!span) {
          return title
        }
        this.selectedTextElement = span[0]
      }

      if (this.selectedTextElement.offsetWidth < this.selectedTextElement.scrollWidth) {
        if (this.disabled) {
          return label + '\n\n' + title
        }
        return title
      }

      return this.disabled ? this.disabledText : ''
    },

    toggle () {
      if (!this.disabled) {
        this.shown = !this.shown
      }
    },

    close () {
      this.shown = false
    }
  },

  mounted () {
    this.element = this.$el
    /**
     * É feito o seguinte cálculo para limitar o tamanho máximo de filtro do gadget:
     * ⌊Tamanho da barra ÷ Quantidade de filtros⌋ - Offset
     * Onde:
     * - Tamanho da barra: 100% em referência ao elemento pai, que no caso é o .filters-common;
     * - Quantidade de filtros: quantidade de filtros que esse gadget possui;
     * - Offset: uma constante de 15px em relação a extrema direita do menu para poder ter um espaço para o botão de fechar o gadget.
     **/
    this.element.style.maxWidth = `calc(${Math.floor(100 / this.quantity)}% - 15px)`
  },

  created () {
    if (this.options.length > 0) {
      this.selected = this.getSelected()
      this.hasData = true
    }
    this.disabled = this.options.length === 1
  }
}
</script>

<style scoped>
.filter-common {
  min-width: 50px;
  margin-right: 10px;
}

.filter-common-selected {
  margin: 4px 0px 0px 4px;
  padding: 1px 0px;
  line-height: 27px;
  display: flex;
  flex-flow: row nowrap;
  flex: 1 1 auto;
}

.filter-common-selected > .filter-common-selected-text {
  transition: 0.1s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-common.closed > .filter-common-selected > .filter-common-selected-text {
  opacity: 1;
}

.filter-common.open > .filter-common-selected > .filter-common-selected-text {
  opacity: 0.5;
}

.filter-common-arrow {
  background-image: url('../../../assets/icones_app/arrow.svg');
  background-repeat: no-repeat;
  height: 10px;
  min-width: 17px;
  margin-left: 7px;
  margin-top: 8px;
  transition: 0.15s;
}

.filter-common.open > .filter-common-selected > .filter-common-arrow {
  transform: rotate(180deg);
}

.filter-common-list {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, .26);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  border-top: none;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, .15);
  margin-top: 3px;
  position: absolute;
  z-index: 700!important;
  max-height: 400px;
  overflow: auto;
  white-space: nowrap;
}

.filter-common-list-item {
  color: #000000;
  padding: 5px 15px 5px 15px;
  transition: 0.1s;
}

.filter-common-list-item:hover, .filter-group-list-item:hover {
  background-color: #5897fb;
  color: #ffffff;
}

.disabled {
  cursor: not-allowed;
}

.magin-small{
  margin: 5px 10px 10px;
}

.group-title {
  color: #1A3B5F;
  font-weight: bold;
  padding: 10px 15px 5px 15px;
  transition: 0.1s;
}

.filter-group-list-item {
  color: #000000;
  padding: 5px 15px 5px 25px;
  transition: 0.1s;
}
</style>



// WEBPACK FOOTER //
// FilterCommon.vue?0ddf26ce